import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * The single promo the whole site advertises — the offer the admin flagged as
 * featured, else the newest live one. `null` means nothing is running, which is how
 * the sticky bar and the carousel badge stay in sync and disappear together.
 */
export const useActivePromo = () => {
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/promo/active")
      .then(({ data }) => { if (alive) setPromo(data.promo || null); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return promo;
};

export default useActivePromo;
